import { v4 } from "uuid";

const ADD_TOAST = "toasts/ADD_TOAST";
const SET_SHOW = "toasts/SET_SHOW";

const initialState = {
  toasts: [],
};

const toasts = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TOAST:
      return {
        ...state,
        toasts: [...state.toasts, action.toast],
      };
    case SET_SHOW:
      const i = state.toasts.findIndex((toast) => toast.key === action.key);
      if (i === -1) return state;
      return {
        ...state,
        toasts: [...state.toasts.slice(0, i), { ...state.toasts[i], show: action.show }, ...state.toasts.slice(i + 1)],
      };
    default:
      return state;
  }
};

const addToast = ({ key, toast }) => ({
  key,
  toast,
  type: ADD_TOAST,
});

const setShow = ({ key, show }) => ({ key, show, type: SET_SHOW });

export const toast = (text) => (dispatch) => {
  const key = v4();
  const toast = {
    key,
    show: true,
    text,
  };
  dispatch(addToast({ key, toast }));
};

export const hide = (key) => (dispatch) => dispatch(setShow({ key, show: false }));

export default toasts;
